import React from 'react';
import { 
    Edit, 
    SimpleForm, 
    ReferenceInput,
    SelectInput,
    BooleanInput,
    TextField,
    required
} from 'react-admin';
import { Typography, Box } from '@mui/material';
import { FormToolbar } from "../../common/FormToolbar";

const SectionTitle = ({ children }) => (
    <Box sx={{ mt: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom>
            {children}
        </Typography>
    </Box>
);

// Access level choices
const accessLevelChoices = [
    { id: 'VIEW', name: 'View Only - Can view data but cannot edit' },
    { id: 'EDIT', name: 'Edit - Can view and modify data' },
    { id: 'ADMIN', name: 'Admin - Full access including delete' },
];

export const UserBranchAccessEdit = props => {
    return (
        <React.Fragment>
            <Edit label="Edit Branch Access" {...props}>
                <SimpleForm toolbar={<FormToolbar {...props} />}>
                    <TextField source="id" label="ID" />
                    
                    <SectionTitle>User Branch Access Configuration</SectionTitle>
                    
                    <ReferenceInput 
                        source="user_id" 
                        reference="user" 
                        label="User"
                        fullWidth={true}
                        disabled
                    >
                        <SelectInput optionText="username" />
                    </ReferenceInput>

                    <ReferenceInput 
                        source="branch_id" 
                        reference="branch" 
                        label="Branch"
                        fullWidth={true}
                        disabled
                    >
                        <SelectInput optionText="branch_name" />
                    </ReferenceInput>

                    <SelectInput 
                        source="access_level" 
                        label="Access Level" 
                        choices={accessLevelChoices} 
                        validate={[required()]} 
                        fullWidth={true}
                        helperText="Define what level of access this user has for this branch"
                    />

                    <BooleanInput 
                        source="is_primary_branch" 
                        label="Set as Primary Branch" 
                        helperText="User's primary branch will be the default branch in the system. Setting this will unset any other primary branch for this user."
                    />

                    <BooleanInput 
                        source="status" 
                        label="Active" 
                        helperText="Only active access grants are effective. Uncheck to revoke access."
                    />
                </SimpleForm>
            </Edit>
        </React.Fragment>
    );
};
